<template>
  <div class="nav-wrapper">
    <div class="nav">
      <div v-if="navBackVisible()" class="form-button" @click="$emit('back')"><Zondicon icon="CheveronLeft"/></div>
      <div class="form-button" :class="{'is-only': navHomeOnlyVisible()}" @click="$emit('restart')"><Zondicon icon="ReplyAll"/></div>
      <div v-if="navForwardVisible()" class="form-button" @click="$emit('next')"><Zondicon icon="CheveronRight"/></div>
    </div>
    <!-- <form-progress /> -->
  </div>
</template>
<script>
// import FormProgress from "./FormProgress.vue"

export default {
  name: "form-nav",
  inject: ["formState"],
  // components: {
  //   "form-progress": FormProgress
  // },
  methods: {
    navBackVisible() {
      return this.formState.navBackVisible;
    },
    navForwardVisible() {
      return this.formState.navForwardVisible;
    },
    navHomeOnlyVisible() {
      return this.formState.navHomeOnlyVisible;
    }
  }
}
</script>
